import { useEffect } from "react";

interface ExternalAppOpenerProps {
  url: string;
}

export function ExternalAppOpener({ url }: ExternalAppOpenerProps): null {
  useEffect(() => {
    const externalAppUrl = url;
    window.open(externalAppUrl, "_self");
  }, []);

  return null;
}
